// extracted by mini-css-extract-plugin
module.exports = {"flat-card-body":"FlatCardBody_flat-card-body__xxHZ1"};